import React, { useState } from 'react';
import { Button } from '@ftdr/blueprint-components-react';
import { isEmailValid } from '@services/validation/ValidationRules';
import ShareDocument from './subcomponents/ShareDocument';
import Modal from './Modal';
import { getCurrentThemeConfig } from '@app/core/theme-config';

const ModalShareDocument = (props) => {
  const [email, setEmail] = useState('');

  const actions = [
    <Button
      key="submit"
      id="share-doc-send-email-button"
      size="small"
      label="Send Email"
      onClick={() => props.handleSendEmail(email)}
      disabled={!isEmailValid(email)}
      className={getCurrentThemeConfig().modalStyleButton}
      color={getCurrentThemeConfig().modalOkStyleButtonColor}
    />,
    <Button
      key="cancel"
      id="share-doc-cancel-button"
      autoFocus={true}
      variant={getCurrentThemeConfig().modelCancelButtonVariant}
      size="small"
      label="Cancel"
      onClick={props.hideDialog}
      disabled={false}
      className={getCurrentThemeConfig().modalStyleButton}
    />,
  ];

  return (
    <Modal
      id={props.id || 'share-document-modal'}
      heading={props.header || 'Share'}
      isActive={props.isActive}
      onClose={props.hideDialog}
      actions={actions}
    >
      {props.isActive && <ShareDocument setEmail={setEmail} {...props} />}
    </Modal>
  );
};

export default ModalShareDocument;
